// client/src/hooks/usePublicOffice.js — which state's public site this is, and its own
// office facts, for the public pages (audit 2026-10, H8).
//
// The footer, home, about and registry pages carried Illinois text — "Chicago, Illinois",
// the Illinois managing broker's licence number, "Illinois Real Estate License Act",
// "pending with IDFPR" — and the Florida site showed it too. The Florida wording now
// comes from data: the jurisdiction profile (lib/jurisdiction.js publicProfile) and the
// office facts the managing broker keeps in the portal (/api/public/office-info). The
// Illinois pages are left exactly as they were.
import { useEffect, useState } from 'react';
import { siteFromDocument } from '../utils/siteBrand';

let pending = null;
const load = () => {
    if (!pending) {
        const get = (u) => fetch(u).then((r) => (r.ok ? r.json() : null)).catch(() => null);
        pending = Promise.all([get('/api/public/jurisdiction'), get('/api/public/office-info')])
            .then(([jurisdiction, office]) => ({ jurisdiction, office }));
    }
    return pending;
};

// O8 (audit 2026-10): the Illinois footer/home facts, from Virtual Office Settings via
// /api/public/office-info. Until that answers, the values the pages always showed.
export const IL_CONTACT_FALLBACK = {
    public_broker_name: 'Alex George',
    public_broker_license: '471.001905',
    public_contact_email: 'info@bizrec.net',
    public_contact_phone: '(773) 205-5493',
    public_service_address: '4507 W Lawrence Ave., Chicago, IL 60630',
};
export const illinoisContact = (office) => ({ ...IL_CONTACT_FALLBACK, ...((office && office.public_contact) || {}) });

export default function usePublicOffice() {
    const [state, setState] = useState({ jurisdiction: null, office: null });
    useEffect(() => {
        let live = true;
        load().then((s) => { if (live) setState(s); });
        return () => { live = false; };
    }, []);
    const j = state.jurisdiction;
    // The server marks the page (<html data-site>), so Florida is known before the fetch.
    const site = (j && j.code) || siteFromDocument(typeof document !== 'undefined' ? document : null) || 'IL';
    return { ...state, isFL: site === 'FL', loaded: !!j };
}
